import React from 'react'
import { benefits } from '../../constants/benefitData'

const Benefits = () => {
    return (
        <section id="beneficios" className="py-20 bg-slate-900/50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold mb-4">¿Por qué elegirnos?</h2>
                    <p className="text-gray-400 text-lg">Ventajas que nos distinguen en el mercado</p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="text-center group">
                            <div className="mb-6 flex justify-center">
                                <div className="p-4 bg-purple-600/80 rounded-full group-hover:bg-purple-600/30 transition-colors">
                                    <div className="h-10 w-10 flex items-center justify-center text-purple-200">    {benefit.icon}          </div>
                                </div>
                            </div>
                            <h3 className="text-xl font-semibold mb-4">{benefit.title}</h3>
                            <p className="text-gray-200">{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
export default Benefits